import { push } from '@lagunovsky/redux-react-router'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { H_CAMPAIGN_PLUVIO_TRACKING } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CampaignTracking from '../../../campaign/components/campaignTracking/CampaignTracking'
import CampaignDto from '../../../campaign/dto/CampaignDto'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import PluviometerDto from '../../dto/PluviometerDto'


class PluviometryCampaignTrackingApp extends Component {
    componentDidMount = () => {
        if (!componentHasHabilitations(H_CAMPAIGN_PLUVIO_TRACKING)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        this.props.fetchPluviometryCampaignEvent(this.props.params.id)
    }

    componentDidUpdate = prevProps => {
        if (this.props.params.id !== prevProps.params.id) {
            this.props.fetchPluviometryCampaignEvent(this.props.params.id)
        }
    }

    render = () => (
        <CampaignTracking
            params={this.props.params}
            stations={this.props.pluviometers}
            stationType='pluviometry'
        />
    )
}

PluviometryCampaignTrackingApp.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
    campaign: PropTypes.instanceOf(CampaignDto),
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    push: PropTypes.func,
    fetchPluviometryCampaignEvent: PropTypes.func,
}

const mapStateToProps = store => ({
    campaign: store.CampaignReducer.campaign,
    pluviometers: store.PluviometryReducer.pluviometers,
})

const mapDispatchToProps = {
    fetchPluviometryCampaignEvent: CampaignAction.fetchPluviometryCampaignEvent,
    push,
}

export default connect(mapStateToProps, mapDispatchToProps)(PluviometryCampaignTrackingApp)